import React from 'react';
import { Grid } from '@mui/material';
import { dropBoolean } from 'utils/drops';
import Input from 'components/Input';
import Dropdown from 'components/Dropdown';

const Filter = ({ grid, control, drops }) => {
  const checkDisplay = (name) => {
    const column = grid?.colunas?.find((c) => c?.field === name);
    if (column?.filterable) {
      return true;
    }
    return false;
  };

  return (
    <Grid container spacing={2}>
      {checkDisplay('id') && (
        <Grid item xs={12}>
          <Input name="id" control={control} label="ID" type="number" />
        </Grid>
      )}
      {checkDisplay('modelo') && (
        <Grid item xs={12}>
          <Input name="modelo" control={control} label="Modelo" />
        </Grid>
      )}
      {checkDisplay('marca') && (
        <Grid item xs={12}>
          <Dropdown
            name="marca"
            control={control}
            label="Marca"
            options={drops?.Marca}
            multiple
          />
        </Grid>
      )}
      {checkDisplay('anofab') && (
        <Grid item xs={12}>
          <Input
            name="anofab"
            control={control}
            label="Ano de Fabricação"
            type="number"
          />
        </Grid>
      )}
      {checkDisplay('ativo') && (
        <Grid item xs={12}>
          <Dropdown
            name="ativo"
            control={control}
            label="Ativo"
            options={dropBoolean}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Filter;
